import { IBusinessConfigs } from '../_Common/Const/BusinessConfigs';
import { initConst } from '../../../Utils/utils';

const DIBusinessConfig = initConst<IBusinessConfigs>(() => ({
  DIPostlista: {
    defaultColumns: [
      { attributeDef: 'PLOPNR2', caption: 'Dnr' },
      { attributeDef: 'Dokument.ANKOMST', caption: 'Datum' },
      { attributeDef: 'Dokument.BESKRIVNING', caption: 'Rubrik' },
      { attributeDef: 'Dokument.handTyp.BENAMNING', caption: 'Handlingstyp' },
      { attributeDef: 'Dokument.AvsandareNamn', caption: 'Avsändare' },
      { attributeDef: 'Dokument.MottagareNamn', caption: 'Mottagare' },
      { attributeDef: 'arendenr', caption: 'Ärende' },
      { attributeDef: 'Dokument.Handling.LOPNR', caption: 'Handling' },
      { attributeDef: 'Diarieplan', caption: 'Diarieplan' },
      { attributeDef: 'Dokument.ARKIVPLATS', caption: 'Arkivplats' },
      { attributeDef: 'Dokument.Filnamn', caption: 'Filnamn' },
      { attributeDef: 'Dokument.BESLUTTEXT', caption: 'Beslut' },
      { attributeDef: 'Dokument.BESLUTSDATUM', caption: 'Beslutsdatum' },
      { attributeDef: 'ANVANDARSIGN', caption: 'Registrator' },
    ],
  },
  DIArende: {
    defaultColumns: [
      { attributeDef: 'Diarienr2', caption: 'Ärendenr' },
      { attributeDef: 'INITDATUM', caption: 'Datum' },
      { attributeDef: 'RUBRIK', caption: 'Ärenderubrik' },
      { attributeDef: 'AVSLUT', caption: 'Avslut' },
      { attributeDef: 'BEVAKNING', caption: 'Bevakning' },
      { attributeDef: 'Handnamn', caption: 'Handläggare' },
    ],
  },
  DIDokument: {
    defaultColumns: [
      { attributeDef: 'Dokumenttyp', caption: 'Dokumenttyp' },
      { attributeDef: 'BESKRIVNING', caption: 'Rubrik' },
      { attributeDef: 'ARKIVPLATS', caption: 'Arkivplats' },
      { attributeDef: 'PostlisteNR', caption: 'Diarienummer' },
      { attributeDef: 'Diarienr2', caption: 'Ärendenummer' },
      { attributeDef: 'Filnamn', caption: 'Ursprungligt filnamn' },
      { attributeDef: 'Fildatum', caption: 'Fildatum' },
    ],
  },
  DIDiarieplan: {
    defaultColumns: [
      { attributeDef: 'DIARIEPLANNR', caption: 'Diarieplan' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'AvsMotNamn', caption: '' },
    ],
  },
  DIAvsMot: { defaultColumns: [{ attributeDef: 'NAMN', caption: 'Namn' }] },
  DIHandlaggare: {
    defaultColumns: [
      { attributeDef: 'FORK', caption: 'Sign.' },
      { attributeDef: 'NAMN', caption: 'Namn' },
    ],
  },
  DIHandlingstyp: {
    defaultColumns: [{ attributeDef: 'BENAMNING', caption: 'Benämning' }],
  },
}));

export default DIBusinessConfig;
